import { Trans } from '@lingui/react';
import { Avatar } from '@startuptools/ui/Avatar';
import { IconButton } from '@startuptools/ui/IconButton';
import { Tooltip } from '@startuptools/ui/Tooltip';
import { Typography } from '@startuptools/ui/Typography';
import DeleteIcon from '@mui/icons-material/Delete';
import { IdentityDisplay } from '@startuptools/business-ui/identity/IdentityDisplay';
import { GqlCompanyUser, type GqlUser } from '../../../graphql/base-types.graphql';

export const UserTableRow = ({
  companyUser,
  handleDeleteUserClick,
  showDeleteUserButton,
  currentUser,
}: {
  companyUser: Pick<GqlCompanyUser, 'id'> & { user: Pick<GqlUser, 'name' | 'personalId' | 'email' | 'phone'> };
  handleDeleteUserClick: (companyUser: Pick<GqlCompanyUser, 'id'>) => void;
  showDeleteUserButton: boolean;
  currentUser: Pick<GqlUser, 'admin'>;
}) => {
  return (
    <tr>
      <td>
        <IdentityDisplay
          name={companyUser.user.name}
          startDecorator={
            <Avatar variant="solid" color="primary">
              <Typography level="title-lg" sx={{ color: 'white' }}>
                {companyUser.user.name?.[0]}
              </Typography>
            </Avatar>
          }
        />
      </td>
      <td>
        <Trans id="Admin" />
      </td>
      {currentUser.admin && (
        <>
          <td>{companyUser.user.personalId}</td>
          <td>{companyUser.user.email}</td>
          <td>{companyUser.user.phone}</td>
        </>
      )}
      <td align="right">
        {showDeleteUserButton && (
          <Tooltip title={<Trans id="Delete User" />}>
            <IconButton onClick={() => handleDeleteUserClick(companyUser)} color="danger" variant="outlined">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </td>
    </tr>
  );
};
